/** Campaign participation gate — influencer apply / submit / message blocking. */

export type CampaignParticipationBlockedReasonCode =
    | 'payment_dispute_open'
    | 'payment_dispute_or_refund'
    | 'insufficient_campaign_funds'
    | 'campaign_paused'
    | 'campaign_not_published'
    | 'campaign_not_funded'
    | 'campaign_ended'
    | 'campaign_closed'
    | 'campaign_deleted'
    | 'campaign_at_capacity'
    | string;

export type CampaignStatusDisplay = 'active' | 'paused' | 'ended' | 'draft' | 'not_funded' | 'closed' | string;

export interface ICampaignParticipationGate {
    participation_allowed: boolean;
    blocked_reason_code: CampaignParticipationBlockedReasonCode | null;
    blocked_reason_title: string | null;
    blocked_reason_message: string | null;
    campaign_status_display: CampaignStatusDisplay;
    /** Past end_date but creator may still message / revise / submit live URLs. */
    post_end_in_flight?: boolean;
    campaign_end_date?: string | null;
}

export const CAMPAIGN_PARTICIPATION_BLOCKED_CODE = 'CAMPAIGN_PARTICIPATION_BLOCKED';
